import { ApolloClient, HttpLink, from, InMemoryCache, gql } from '@apollo/client'

const GET_CONTENT_TITLES = gql`
  query getContentByContentId($contentId: [Int!]) {
    contentList(where: { contentId: { in: $contentId } }) {
      content {
        contentId
        title
      }
    }
  }
`

export async function fetchContentIdToTitleMap (contentIds, graphqlServerUrl, auth) {
  const apolloClient = new ApolloClient({
    link: from([
      new HttpLink({
        uri: `${graphqlServerUrl}/graphql`,
        headers: auth ? { authorization: typeof auth === 'function' ? auth() : auth } : {},
      }),
    ]),
    cache: new InMemoryCache(),
  })
  const map = {}
  // Refactor the async function to use Promise.all and array map instead of for...of and await in loop.
  await Promise.all(
    contentIds.map(async (id) => {
      try {
        const { data } = await apolloClient.query({
          query: GET_CONTENT_TITLES,
          variables: { contentId: [id] },
        })
        if (data && data.contentList && data.contentList.content && data.contentList.content[0]) {
          map[id] = data.contentList.content[0].title
        }
      } catch (err) {
        // Ignore individual errors
      }
    }),
  )
  return map
}
